import { effect } from "@preact/signals";
import * as preact from "preact";

import BookStore from "stores/BookStore";
import stores from "stores/stores";
import * as signupModal from "../signupModal";
import * as libraryDocumentViewUtils from "../views/libraryDocumentViewUtils";
import BookCoverView from "./BookCoverView";

interface Props {
  book: BookStore;
  userID: string;
  compactMode?: boolean;
}

type State = {};

export default class BookCoverConnector extends preact.Component<Props, State> {
  disposers: Array<() => void> = [];

  constructor(props: Props) {
    super(props);

    this.disposers.push(
      effect(() => {
        void this.props.book.book.value;
        this.forceUpdate();
      })
    );

    this.state = {};
  }

  componentWillUnmount() {
    for (const dispose of this.disposers) dispose();
    this.disposers = [];
  }

  async clickHeart() {
    if (
      await signupModal.showIfSignedOut({
        heading: (
          <>
            Sign in to <strong>like texts</strong>
          </>
        ),
        stores,
      })
    ) {
      return;
    }

    if ((this.props.book.book.value.yourVote ?? 0) > 0) {
      this.props.book.vote(0);
    } else {
      this.props.book.vote(1);
    }
  }

  async clickReadLater() {
    if (
      await signupModal.showIfSignedOut({
        heading: (
          <>
            Sign in to <strong>save texts</strong>
          </>
        ),
        stores,
      })
    ) {
      return;
    }

    const tagName = "queue";
    this.props.book.addTag(tagName);
  }

  render() {
    const templateData = libraryDocumentViewUtils.calcTemplateData(
      this.props.book.viewJSON(this.props.userID, true),
      {
        userID: this.props.userID,
        groupMode: false,
      }
    );

    return (
      <BookCoverView
        {...templateData}
        clickHeart={() => this.clickHeart()}
        clickReadLater={() => this.clickReadLater()}
        compactMode={this.props.compactMode}
      />
    );
  }
}
